/* istanbul ignore file */

/* tslint:disable */

/* eslint-disable */

/**
 * Provider request result
 */
export var ProviderRequestStatus;

(function (ProviderRequestStatus) {
  ProviderRequestStatus["OK"] = "OK";
  ProviderRequestStatus["ERROR"] = "ERROR";
})(ProviderRequestStatus || (ProviderRequestStatus = {}));